import { noop } from 'lodash';
import { createContext, memo, type ReactNode } from 'react';

import { useMemoizedBundle } from '@didaskill/ui/utils';

type RadioButtonGroupContextValue = {
  /** Selected value. */
  value: string;
  /** On change function. */
  onChange: (newValue?: string) => void;
};

export const RadioButtonGroupContext = createContext<RadioButtonGroupContextValue>({
  value: null,
  onChange: noop,
});

export type RadioButtonGroupContextProviderProps = {
  value?: string;
  onChange?: (newValue?: string) => void;
  children?: ReactNode;
};

export const RadioButtonGroupContextProviderBase = ({
  value = null,
  onChange = noop,
  children = null,
}: RadioButtonGroupContextProviderProps) => {
  const contextValue = useMemoizedBundle({
    value,
    onChange,
  });

  return (
    <RadioButtonGroupContext.Provider value={contextValue}>
      {children}
    </RadioButtonGroupContext.Provider>
  );
};

RadioButtonGroupContextProviderBase.displayName = 'RadioButtonGroupContextProvider';

export const RadioButtonGroupContextProvider = memo(RadioButtonGroupContextProviderBase);
